import { useContext, useState, useEffect } from 'react';
import { getGridStringOperators } from '@mui/x-data-grid';
import useAdminAPI from 'src/services/useAdminAPI';
import { useLoaded } from 'src/store/load-context';
import ToastContext from 'src/store/toast-context';
import LoadingBackdrop from 'src/components/LoadingBackdrop';
import Header from 'src/components/page/Header';
import Footer from 'src/components/layout/Footer';
import AuthContext from 'src/store/auth-context';
import AdminAuthContext from 'src/store/admin-auth-context';

import AccountDetailsBody from 'src/components/admin/AccountDetailsBody';
import handleNull from 'src/util/handleNull';

const BackdoorAccountDetails = ({ location }) => {
  const { logout } = useContext(AdminAuthContext);

  const search = location.search;
  const taxYear = new URLSearchParams(search).get('taxYear');
  const accountNo = new URLSearchParams(search).get('accountNo');
  const { loginBackdoor } = useContext(AuthContext);
  const api = useAdminAPI();
  const { loaded, setLoaded } = useLoaded();
  const { handleError, success } = useContext(ToastContext);
  const [detailInfo, setDetailInfo] = useState({});
  const [activityRows, setActivityRows] = useState([]);

  const fetchDetailFilings = async () => {
    try {
      const res = await api.get(`/admin/filing/details`, {
        params: { accountNo, taxYear },
      });
      return handleNull(res.data);
    } catch (err) {
      console.error(err);
      handleError(err);
    }
  };
  const fetchActivity = async () => {
    try {
      const res = await api.get(`/account/activity`, { params: { accountNo, taxYear } });
      return handleNull(res.data);
    } catch (err) {
      console.error(err);
      handleError(err);
    }
  };

  const updateRows = async () => {
    const detailData = await fetchDetailFilings();
    const activityData = await fetchActivity();
    setDetailInfo(detailData);
    setActivityRows(createActivityRows(activityData));
    setLoaded(true);
  };

  useEffect(() => {
    setLoaded(false);
    updateRows(); //call both api
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const createActivityRows = (activityData) =>
    activityData?.map(({ acctNum, taxYear, dueDate, ppdType, typeDesc }, index) => ({
      id: index,
      acctNum,
      taxYear,
      dueDate,
      ppdType,
      typeDesc,
    }));

  const filterOperators = getGridStringOperators().filter(({ value }) =>
    ['equals', 'contains'].includes(value)
  );

  const columns = [
    { field: 'acctNum', headerName: 'Account #', filterOperators, width: 140 },
    { field: 'taxYear', headerName: 'Tax Year', filterOperators, width: 130 },
    { field: 'dueDate', headerName: 'Due Date', filterOperators, width: 200 },
    { field: 'ppdType', headerName: 'PPD Type', filterOperators, width: 150 },
    { field: 'typeDesc', headerName: 'Type Desc', filterOperators, width: 500 },
  ];

  return (
    <>
      <LoadingBackdrop loading={!loaded} />
      <Header onLogout={logout} />
      {
        <AccountDetailsBody
          {...{
            accountNo,
            columns,
            taxYear,
            detailInfo,
            handleError,
            loginBackdoor,
            success,
            activityRows,
          }}
        />
      }
      <Footer />
    </>
  );
};

export default BackdoorAccountDetails;
